<template>
  <div>
    <div v-if="isUpload===true">

        <h6>1. Выберите партнера</h6>
        <h6>2. Выберите торговую точку</h6>
        <h6>3. Нажмите на кнопку "Выгрузить" </h6>

        <selector
            :selectKey="`title`"
            v-model="partner"
            :title="`1. Выберите партнера`"
            :modal="`partner`"
          />

        <selector
            v-if="partner && partner.id"
            :selectKey="`title`"
            v-model="shop"
            :title="`2. Выберите торговую точку`"
            :modal="`shop`"
            :params="{partner_id:partner.id}"
          />
      
    
            <button

                v-if="shop && partner && shop.id && partner.id"
                class="btn btn-sm btn-danger btn-icon mt-2 mr-2"
                @click="orderExport(id,shop,partner)"
              >
                <span class="ti-upload"></span>
                Выгрузить
         </button>
            <button
                      class="btn btn-sm btn-warning btn-icon mt-2"
                @click="isUpload=false; shop=null;partner = null"
             
              >
             
                Отмена
         </button>

         <br/>

      
      </div>

      <div v-else>


         <button
              class="btn btn-sm btn-info btn-icon mt-2"
                @click="isUpload=true"
             
              >
                Выгрзить заказ
         </button>

       <list
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :params="{...params,id:id}"
        :isUpdate="true"
        :isAdd="false"
        :itemLink="itemLink"
        :setLink="setLink"
        :fields="fields"
        :searchDisable="true"

        v-model="val"
 
      />
      </div>
     
  </div>
</template>

<script>
import List from "@/components/List";

import {orderExport} from '@/_api/orderExport'

/**Меняю добавление модалку */

export default {
  name: "groups",
  methods: {
    orderExport:orderExport
  },
  components: {
    /**Меняю добавление модалку */
    List,
    selector: () => import("@/components/Inputs/Selector"),
  },
  props: ["id"],
  data() {
    return {
      isUpload:false,
      shop:null,
      partner:null,

      val: [],
      modalCreate: "",
      fields: [

      ],
      params:{},
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "orders/export/list",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "title",
          title: "Название",
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "pivot",
          title: "Статус",
          object: "status",
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "pivot",
          title: "ID Партнера",
          object: "uniq_id",
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "pivot",
          title: "Дата запроса",
          object: "created_at",

          timer: false,
          detail: false,
          dateTimeFormat:true,
        },
        {
          key: "pivot",
          title: "Магазин",
          object: "shop",

          timer: false,
          detail: false,
      
        },
      ],
    };
  },

  watch:{
       partner: {
          handler: function (val) {

            if (val) {
                this.shop = null
            }
      },
      deep: true,
      immediate: true,
    },
  }

};
</script>
<style>
</style>
